import React from 'react';
import {
    Drawer,
    Box,
    Typography,
    Accordion,
    AccordionSummary,
    AccordionDetails,
    List,
    ListItemButton,
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import CheckIcon from '@mui/icons-material/TaskAlt';

function Sidebar({ modules, isDrawerOpen, toggleDrawer, courseSlug }) {
    const handleNavigation = (lessonId) => {
        window.location.assign(`/course/${courseSlug}/lesson/${lessonId}`);
    };

    return (
        <>
            {/* Desktop Sidebar */}
            <Box
                sx={{
                    // display: { xs: 'none', md: 'block' },
                    display: { xs: 'none', md: 'flex' }, // Ensure flex layout
                    flexDirection: 'column', // Stack elements vertically
                    width: '320px',
                    borderRight: '1px solid #ddd',
                    backgroundColor: '#f8fafc',
                    p: 2,
                    overflowY: 'auto',
                    // maxHeight: 'auto',
                    height: '100vh', // Full viewport height
                }}
            >
                <Typography variant="h6" fontWeight="bold" sx={{ mb: 2, textAlign: 'left', color: '#333' }}>
                    Course Content
                </Typography>
                {modules.map((module, index) => (
                    <Accordion
                        key={module._id || index}
                        disableGutters
                        square
                        sx={{ borderBottom: '1px solid #ddd', '&:before': { display: 'none' } }}
                    >
                        <AccordionSummary
                            expandIcon={<ExpandMoreIcon />}
                            sx={{ backgroundColor: '#f8fafc', '&:hover': { backgroundColor: '#f0f4f8' } }}
                        >
                            <Typography>{module.title}</Typography>
                        </AccordionSummary>
                        <AccordionDetails>
                            <List disablePadding>
                                {module.lessons && module.lessons.length > 0 ? (
                                    module.lessons.map((lesson) => (
                                        <ListItemButton
                                            key={lesson._id}
                                            sx={{
                                                pl: 2,
                                                '&:hover': { backgroundColor: '#f0f4f8' },
                                                display: 'flex',
                                                justifyContent: 'space-between', // Align text and icon
                                            }}
                                            onClick={() => handleNavigation(lesson._id)}
                                        >
                                            <Typography sx={{ color: '#555' }}>{lesson.title}</Typography>
                                            {lesson.completed && (
                                                <CheckIcon
                                                    sx={{
                                                        color: 'green', // Green color to indicate completion
                                                        ml: 2,
                                                        fontSize: '18px'
                                                    }}
                                                />
                                            )}
                                        </ListItemButton>
                                    ))
                                ) : (
                                    <Typography sx={{ color: 'text.secondary', px: 2 }}>
                                        No lessons available
                                    </Typography>
                                )}
                            </List>
                        </AccordionDetails>
                    </Accordion>
                ))}
            </Box>

            {/* Mobile Drawer Sidebar */}
            <Drawer
                anchor="left"
                open={isDrawerOpen}
                onClose={toggleDrawer}
                ModalProps={{
                    keepMounted: true, // Better performance on mobile
                }}
                sx={{
                    '& .MuiDrawer-paper': {
                        width: 320,
                        backgroundColor: '#f8f9fa',
                    },
                }}
            >
                <Box sx={{ p: 2 }}>
                    <Typography variant="h6" fontWeight="bold" sx={{ mb: 2, textAlign: 'left', color: '#333' }}>
                        Course Content
                    </Typography>
                    {modules.map((module, index) => (
                        <Accordion
                            key={module._id || index}
                            disableGutters
                            square
                            sx={{ borderBottom: '1px solid #ddd', '&:before': { display: 'none' } }}
                        >
                            <AccordionSummary
                                expandIcon={<ExpandMoreIcon />}
                                sx={{ backgroundColor: '#f8fafc', '&:hover': { backgroundColor: '#f0f4f8' } }}
                            >
                                <Typography fontWeight="bold">{module.title}</Typography>
                            </AccordionSummary>
                            <AccordionDetails>
                                <List disablePadding>
                                    {module.lessons && module.lessons.length > 0 ? (
                                        module.lessons.map((lesson) => (
                                            <ListItemButton
                                                key={lesson._id}
                                                sx={{
                                                    pl: 2,
                                                    '&:hover': { backgroundColor: '#f0f4f8' },
                                                    display: 'flex',
                                                    justifyContent: 'space-between', // Align text and icon
                                                }}
                                                onClick={() => handleNavigation(lesson._id)}
                                            >
                                                <Typography sx={{ color: '#555' }}>{lesson.title}</Typography>
                                                {lesson.completed && (
                                                    <CheckIcon
                                                        sx={{
                                                            color: 'green', // Green color to indicate completion
                                                            ml: 2,
                                                            fontSize: '18px'
                                                        }}
                                                    />
                                                )}
                                            </ListItemButton>
                                        ))
                                    ) : (
                                        <Typography sx={{ color: 'text.secondary', px: 2 }}>
                                            No lessons available
                                        </Typography>
                                    )}
                                </List>
                            </AccordionDetails>
                        </Accordion>
                    ))}
                </Box>
            </Drawer>
        </>
    );
}

export default Sidebar;
